import React from "react";
import './hoverSection.css';
import { MDBRow, MDBCol, MDBIcon, MDBContainer } from "mdbreact";

class ServiceHoverSection extends React.Component {
  render() {
    return (
      <div className="wrapper">
        <div className="container">
          <MDBRow className="row">
            <MDBCol lg="4" className="item-wrapper stratSect">
              <div>
                <div>
                  <h2 className="title">Services</h2>
                  <div className="description">
                    <p>
                      Web Design, Development, Hosting, Support
                      Responsive Design & Development
                      Web & Mobile applications
                    </p>
                  </div>
                </div>
              </div>
            </MDBCol>
            <MDBCol lg="4" className="item-wrapper developSect">
              <div>
                <div>
                  <h2 className="title">Technologies</h2>
                  <div className="description">
                    <p>
                    HTML5, CSS3, Javascript, JQuery, Bootstrap, 
                    React.js, Gatsby, Django, Restful Framework, 
                    Python, MySQL, PostgreSQL, Graph QL, SQLLITE, 
                    Wordpress
                    </p>
                  </div>
                </div>
              </div>
            </MDBCol>
            <MDBCol lg="4" className="item-wrapper digitalSect">
              <div>
                <div>
                  <h2 className="title">Managed Services</h2>
                  <div className="description">
                    <p>
                      Amazon AWS & EC2
                      Wordpress, Mailchimp, Google Analytics
                      SEO, E-Commerce
                      YouTube & Vimeo</p>
                  </div>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </div>
      </div>
    );
  }
}

export default ServiceHoverSection;
